import { Component, inject, OnInit } from '@angular/core';
import { InputTypeEnum } from '@shared/components/input-container/input-container.component';
import { ConfirmationModalService, ConfirmationModalType } from '@shared/services/confirmation-modal.service';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { IDrawDto } from '@models/draw/dtos/draw-dto';
import { DrawPostForm } from '@models/draw/forms/draw-post-form';
import { DrawService } from '@shared/services/draw.service';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import { IPage } from '@models/pagination/page';
import { BehaviorSubject } from 'rxjs';
import { DrawFilterForm } from '@models/draw/filters/draw-filter';
import { IDrawSimpleDto } from '@models/draw/dtos/draw-simple-dto';
import { ICategoryDto } from '@models/category-dto';
import { LoadingService } from '@shared/services/loading.service';
import { DateTimeEnum } from '@shared/components/date-time-picker/date-time-picker.component';
import { Validators } from '@angular/forms';

@Component({
  selector: 'sigecom-draw-list',
  templateUrl: './draw-list.component.html',
})
export class DrawListComponent extends BaseComponent implements OnInit {
  InputTypeEnum = InputTypeEnum;
  DateTimeEnum = DateTimeEnum;

  public drawFilters = new BehaviorSubject<DrawFilterForm>({
    sorTxNome: '',
    catNrId: 0,
    catTxNome: '',
  });
  public draws?: IDrawSimpleDto[];
  public drawsPage?: IPage<IDrawSimpleDto>;

  categories?: IPage<ICategoryDto>;
  public categoriesList: string[] = [];


  testForm=this.fb.group(
    {
      dateControl : this.fb.control<string>('',[Validators.required]),
      timeControl : this.fb.control<string>('',[Validators.required]),
      datetimeControl : this.fb.control<string>('',[Validators.required])
    }
  )
  pritnform(){
    console.log(this.testForm.value)
  }


  #drawService = inject(DrawService);
  #confirmationModalService = inject(ConfirmationModalService)
  #loadingService = inject(LoadingService);


  ngOnInit(): void {
  this.loadDraws();

  }

  protected navigateToCreate() {
    this.router.navigate(["sorteios","criar"]).then();
  }

  protected navigateToEdit(event: IDrawDto | any) {
    this.router.navigate(["sorteios","editar", event.sorNrId]).then();
  }

  protected print(event: any) {}

  // protected showConfirmationModal(drawDto: IDrawDto) {
  //   this.#confirmationModalService.openModal({
  //     modalType: ConfirmationModalType.danger,
  //     cancelText: 'Cancelar',
  //     confirmText: 'Excluir',
  //     message: "Deseja realmente excluir",
  //     resourceName: drawDto.sorTxDescricao,
  //     callbackExecuteAction: () => this.#delete(drawDto)
  //   });
  // }

  // #delete(drawDto: IDrawDto): void {
  //   let form: DrawPostForm = {
  //     ...drawDto,
  //     sorBlTrocaOrdemConfronto: drawDto.sorBlTrocaOrdemConfronto || false,
  //     entTxMetadado: MetadataPutEnum.DELETADO
  //   }

    // this.functionService.deleteFunction(form).subscribe({
    //   next: () => {
    //     this.snackbarService.showSuccess(`Função ${form.funTxDescricao} excluída`)
    //     this.getFunctions(0);
    //   },
    //   error: err => this.messageErrorResolver.resolveMessage(err)
    // });

  public loadDraws(page: number = 0): void {
    this.#loadingService.activate();
    this.#drawService.findDraws$(this.drawFilters.getValue()!, { page: page, size: 10 }).subscribe({
      next: (res) => {
        this.drawsPage = res;
        const allCategories = res.content?.map(draw => draw.catTxNome).filter(cat => cat) || [];
        this.categoriesList = Array.from(new Set(allCategories));
        this.#loadingService.deactivate();

      },
      error: (err) => {
        this.messageErrorResolver.resolveMessage(err);
      }
    });
  }

  filterByName(sorTxNome: string) {
    this.drawFilters.next({ ...this.drawFilters.getValue(), sorTxNome });
    this.loadDraws(0);
  }

  onPageChange(page: number) {
    this.loadDraws(page);
  }
  filterByCategory(catTxNome: string) {
    this.drawFilters.next({ ...this.drawFilters.getValue(), catTxNome });
    this.loadDraws(0);
  }
}
